import { getTranslation } from '@owc/aem-translations-util';
import { Configuration, LocaleDownloadRequest, LocalesApi } from 'phrase-js';

const projectId = 'f2c813c57001c93e3757b282e2282279';
const phraseUrl = 'https://i18n.oneweb.mercedes-benz.com/';

export const loadTranslations = async (
  language: string,
  country: string,
): Promise<Record<string, string>> => {
  const translations = await getTranslation(
    getLocale(language, country),
    import.meta.env.VITE_PHRASE_PROJECT_ID,
    'i18next',
    {
      include_empty_translations: true,
      fallback_locale_id: 'en-DE',
    },
  );

  return translations;
};

function getLocale(language: string, country: string) {
  return `${language}-${country}`;
}

export async function fetchTranslations(language: string, country: string) {
  const configuration = new Configuration({
    basePath: phraseUrl,
    fetchApi: fetch,
  });

  const localesApi = new LocalesApi(configuration);

  const localeDownloadRequest: LocaleDownloadRequest = {
    projectId: projectId,
    id: getLocale(language, country),
    fileFormat: 'simple_json',
    includeEmptyTranslations: true,
    fallbackLocaleId: 'en-DE',
  };

  const blob = await localesApi.localeDownload(localeDownloadRequest);
  const response = await blob.text();
  const result = await JSON.parse(response);

  return result;
}
